// import React, { useState, useEffect, useRef, useContext } from "react";
// import { Link } from "react-router-dom";
// import { gsap } from "gsap";
// import { Search, User, ShoppingBag, X, Menu } from "lucide-react";
// import CartOffCanvas from "./CartOffCanvas";
// import { useCart } from "../context/CartContext";
// import Auth from "../utils/AuthUtils";
// import { CategoryContext } from "../context/CategoryContext";
// import { useSiteConfig } from "../context/SiteConfigContext";

// const Header = () => {
//     const [isSearchOpen, setIsSearchOpen] = useState(false);
//     const [isCartOpen, setIsCartOpen] = useState(false);
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//      const { config } = useSiteConfig();

//     // ── API / Context integrations ──────────────────────────────────────────
//     const { cartItems } = useCart();
//     const isLoggedIn = Auth.getToken();
//     const { categories } = useContext(CategoryContext);

//     // Total cart item count (sum of quantities)
//     const cartCount = cartItems.reduce((sum, item) => sum + (item.quantity || item.qty || 1), 0);

//     const headerRef = useRef(null);
//     const searchOverlayRef = useRef(null);
//     const menuOverlayRef = useRef(null);

//     const searchTl = useRef(null);
//     const menuTl = useRef(null);

//     // Static nav links (always visible)
//     const staticNavLinks = [
//         { label: "New Arrivals", path: "/new-arrivals" },
//         { label: "About", path: "/about-us" },
//     ];

//     useEffect(() => {
//         let ctx = gsap.context(() => {
//             // 1. Header Entrance
//             gsap.from(".luxury-header", {
//                 y: -100,
//                 opacity: 0,
//                 duration: 1.2,
//                 ease: "expo.out",
//             });

//             // 2. SEARCH TIMELINE
//             searchTl.current = gsap
//                 .timeline({ paused: true })
//                 .set(searchOverlayRef.current, { display: "flex" })
//                 .fromTo(
//                     ".search-bg",
//                     { scaleY: 0 },
//                     { scaleY: 1, duration: 0.8, ease: "expo.inOut" },
//                 )
//                 .fromTo(
//                     [".search-content > *", ".close-search"],
//                     { y: 30, opacity: 0 },
//                     { y: 0, opacity: 1, stagger: 0.1, duration: 0.6, ease: "expo.out" },
//                     "-=0.2",
//                 );

//             // 3. MOBILE MENU TIMELINE
//             menuTl.current = gsap
//                 .timeline({ paused: true })
//                 .set(menuOverlayRef.current, { display: "flex" })
//                 .fromTo(".menu-bg", { opacity: 0 }, { opacity: 1, duration: 0.4 })
//                 .fromTo(
//                     ".menu-sidebar",
//                     { x: "-100%" },
//                     { x: "0%", duration: 0.8, ease: "expo.inOut" },
//                     "-=0.3",
//                 )
//                 .from(
//                     ".menu-link",
//                     { x: -30, opacity: 0, stagger: 0.1, duration: 0.5 },
//                     "-=0.4",
//                 );
//         });
//         return () => ctx.revert();
//     }, []);

//     useEffect(() => {
//         if (searchTl.current) {
//             isSearchOpen ? searchTl.current.play() : searchTl.current.reverse();
//         }
//     }, [isSearchOpen]);

//     useEffect(() => {
//         if (menuTl.current) {
//             isMenuOpen ? menuTl.current.play() : menuTl.current.reverse();
//         }
//     }, [isMenuOpen]);

//     return (
//         <>
//         <header className="luxury-header" ref={headerRef}>
//                 {/* HAMBURGER (Only Mobile) */}
//                 <Link
//                     to="#"
//                     className="icon-link d-lg-none m-0"
//                     onClick={(e) => {
//                         e.preventDefault();
//                         setIsMenuOpen(true);
//                     }}
//                 >
//                     <Menu size={24} strokeWidth={1.5} />
//                 </Link>

//                 {/* LOGO */}
//                 <Link to="/" className="brand-logo">
//                     {/* BEGUM'S */}
//                     <img src={config?.logo} alt="logo" />
//                 </Link>

//                 {/* DESKTOP NAV — Static links + Dynamic categories from API */}
//                 <nav className="d-none d-lg-block">
//                     {/* Collections / categories from API */}
//                     {categories && categories.length > 0 ? (
//                         categories.map((cat) => (
//                             <Link
//                                 key={cat._id}
//                                 to={`/categories/${cat.slugPath}`}
//                                 className="nav-link-item"
//                             >
//                                 {cat.name}
//                             </Link>
//                         ))
//                     ) : (
//                         <Link to="/shop" className="nav-link-item">
//                             Collections
//                         </Link>
//                     )}
//                     {staticNavLinks.map((link, i) => (
//                         <Link key={i} to={link.path} className="nav-link-item">
//                             {link.label}
//                         </Link>
//                     ))}
//                 </nav>

//                 {/* ICONS */}
//                 <div className="d-flex align-items-center">
//                     {/* Search */}
//                     <Link
//                         to="#"
//                         className="icon-link"
//                         onClick={(e) => {
//                             e.preventDefault();
//                             setIsSearchOpen(true);
//                         }}
//                     >
//                         <Search size={22} strokeWidth={1} />
//                     </Link>

//                     {/* User — auth aware */}
//                     <Link
//                         to={isLoggedIn ? "/users/dashboard" : "/users/login"}
//                         className="icon-link d-none d-md-block"
//                     >
//                         <User size={22} strokeWidth={1} />
//                     </Link>

//                     {/* Cart with live count badge */}
//                     <Link
//                         to="#"
//                         className="icon-link position-relative"
//                         onClick={(e) => {
//                             e.preventDefault();
//                             setIsCartOpen(true);
//                         }}
//                     >
//                         <ShoppingBag size={22} strokeWidth={1} />
//                         {cartCount > 0 && (
//                             <span className="cart-icon-badge">{cartCount}</span>
//                         )}
//                     </Link>
//                 </div>
//             </header>

//             {/* --- OVERLAYS --- */}

//             {/* 1. SEARCH */}
//             <div className="manual-overlay" ref={searchOverlayRef}>
//                 <div className="search-bg"></div>
//                 <Link
//                     className="close-btn-luxury close-search"
//                     style={{ right: "3rem" }}
//                     onClick={() => setIsSearchOpen(false)}
//                 >
//                     <X size={35} />
//                 </Link>
//                 <div className="search-content container d-flex flex-column align-items-center justify-content-center h-100 position-relative">
//                     <h6
//                         style={{ color: "var(--color-accent-main)", letterSpacing: "4px" }}
//                     >
//                         CURATED SEARCH
//                     </h6>
//                     <input
//                         type="text"
//                         className="luxury-input"
//                         placeholder="What are you looking for?"
//                         autoFocus
//                     />
//                 </div>
//             </div>

//             {/* 2. CART — real data */}
//             <CartOffCanvas isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />

//             {/* 3. MOBILE MENU */}
//             <div className="manual-overlay" ref={menuOverlayRef}>
//                 <div
//                     className="menu-bg"
//                     style={{
//                         position: "absolute",
//                         inset: 0,
//                         background: "rgba(0,0,0,0.5)",
//                     }}
//                 ></div>
//                 <div className="sidebar menu-sidebar d-flex flex-column">
//                     <button
//                         className="close-btn-luxury"
//                         style={{ right: "2rem" }}
//                         onClick={() => setIsMenuOpen(false)}
//                     >
//                         <X size={28} />
//                     </button>
//                     <span className="brand-logo mb-5" style={{ fontSize: "1.5rem" }}>
//                         {/* BEGUM'S */}
//                         <img src={config?.logo} alt="logo" />
//                     </span>
//                     <div className="d-flex flex-column">
//                         {/* Dynamic categories in mobile menu */}
//                         {categories && categories.length > 0 ? (
//                             categories.map((cat) => (
//                                 <Link
//                                     key={cat._id}
//                                     to={`/categories/${cat.slugPath}`}
//                                     className="menu-link nav-link-item ms-0 mb-4 fs-3"
//                                     onClick={() => setIsMenuOpen(false)}
//                                 >
//                                     {cat.name}
//                                 </Link>
//                             ))
//                         ) : null}
//                         {staticNavLinks.map((link, i) => (
//                             <Link
//                                 key={i}
//                                 to={link.path}
//                                 className="menu-link nav-link-item ms-0 mb-4 fs-3"
//                                 onClick={() => setIsMenuOpen(false)}
//                             >
//                                 {link.label}
//                             </Link>
//                         ))}

//                         {/* Auth link in mobile menu */}
//                         <Link
//                             to={isLoggedIn ? "/users/dashboard" : "/users/login"}
//                             className="menu-link nav-link-item ms-0 mb-4 fs-3"
//                             onClick={() => setIsMenuOpen(false)}
//                         >
//                             {isLoggedIn ? "My Account" : "Login"}
//                         </Link>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Header;

import React, { useState, useEffect, useRef, useContext } from "react";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { Search, User, ShoppingBag, X, Menu } from "lucide-react";
import CartOffCanvas from "./CartOffCanvas";
import { useCart } from "../context/CartContext";
import Auth from "../utils/AuthUtils";
import { CategoryContext } from "../context/CategoryContext";
import { useSiteConfig } from "../context/SiteConfigContext";
import productAPI from "../api/productApi";

const Header = () => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { config } = useSiteConfig();

    // ── Search States ───────────────────────────────────────────────────────
    const [searchText, setSearchText] = useState("");
    const [searchProducts, setSearchProducts] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);

    // ── API / Context integrations ──────────────────────────────────────────
    const { cartItems } = useCart();
    const isLoggedIn = Auth.getToken();
    const { categories } = useContext(CategoryContext);

    const cartCount = cartItems.reduce((sum, item) => sum + (item.quantity || item.qty || 1), 0);

    const headerRef     = useRef(null);
    const searchOverlayRef = useRef(null);
    const menuOverlayRef   = useRef(null);
    const searchTl = useRef(null);
    const menuTl   = useRef(null);

    const staticNavLinks = [
        { label: "New Arrivals", path: "/new-arrivals" },
        { label: "About", path: "/about-us" },
    ];

    // ── GSAP Timelines ──────────────────────────────────────────────────────
    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.from(".luxury-header", {
                y: -100, opacity: 0, duration: 1.2, ease: "expo.out",
            });

            searchTl.current = gsap
                .timeline({ paused: true })
                .set(searchOverlayRef.current, { display: "flex" })
                .fromTo(".search-bg",
                    { scaleY: 0 },
                    { scaleY: 1, duration: 0.8, ease: "expo.inOut" }
                )
                .fromTo(
                    [".search-content > *", ".close-search"],
                    { y: 30, opacity: 0 },
                    { y: 0, opacity: 1, stagger: 0.1, duration: 0.6, ease: "expo.out" },
                    "-=0.2"
                );

            menuTl.current = gsap
                .timeline({ paused: true })
                .set(menuOverlayRef.current, { display: "flex" })
                .fromTo(".menu-bg", { opacity: 0 }, { opacity: 1, duration: 0.4 })
                .fromTo(".menu-sidebar",
                    { x: "-100%" },
                    { x: "0%", duration: 0.8, ease: "expo.inOut" },
                    "-=0.3"
                )
                .from(".menu-link",
                    { x: -30, opacity: 0, stagger: 0.1, duration: 0.5 },
                    "-=0.4"
                );
        });
        return () => ctx.revert();
    }, []);

    useEffect(() => {
        if (searchTl.current) {
            isSearchOpen ? searchTl.current.play() : searchTl.current.reverse();
        }
    }, [isSearchOpen]);

    useEffect(() => {
        if (menuTl.current) {
            isMenuOpen ? menuTl.current.play() : menuTl.current.reverse();
        }
    }, [isMenuOpen]);

    // ── Debounced Product Search ────────────────────────────────────────────
    useEffect(() => {
        if (!searchText.trim()) {
            setSearchProducts([]);
            return;
        }

        const delay = setTimeout(() => {
            fetchProducts(searchText);
        }, 400);

        return () => clearTimeout(delay);
    }, [searchText]);

    const fetchProducts = async (keyword) => {
        setSearchLoading(true);
        try {
            const res = await productAPI.listing({ page: 1, limit: 6, keyword });
            if (res.code === 200) {
                setSearchProducts(res.data.products);
            }
        } catch (err) {
            console.error("Search error:", err);
        } finally {
            setSearchLoading(false);
        }
    };

    // Close search + reset state
    const handleCloseSearch = () => {
        setIsSearchOpen(false);
        setTimeout(() => {
            setSearchText("");
            setSearchProducts([]);
        }, 600); // wait for reverse animation
    };

    // Close on product click
    const handleProductClick = () => {
        handleCloseSearch();
    };

    return (
        <>
            <header className="luxury-header" ref={headerRef}>
                {/* HAMBURGER */}
                <Link
                    to="#"
                    className="icon-link d-lg-none m-0"
                    onClick={(e) => { e.preventDefault(); setIsMenuOpen(true); }}
                >
                    <Menu size={24} strokeWidth={1.5} />
                </Link>

                {/* LOGO */}
                <Link to="/" className="brand-logo">
                    <img src={config?.logo} alt="logo" />
                </Link>

                {/* DESKTOP NAV */}
                <nav className="d-none d-lg-block">
                    {categories && categories.length > 0 ? (
                        categories.map((cat) => (
                            <Link key={cat._id} to={`/categories/${cat.slugPath}`} className="nav-link-item">
                                {cat.name}
                            </Link>
                        ))
                    ) : (
                        <Link to="/shop" className="nav-link-item">Collections</Link>
                    )}
                    {staticNavLinks.map((link, i) => (
                        <Link key={i} to={link.path} className="nav-link-item">{link.label}</Link>
                    ))}
                </nav>

                {/* ICONS */}
                <div className="d-flex align-items-center">
                    <Link
                        to="#"
                        className="icon-link"
                        onClick={(e) => { e.preventDefault(); setIsSearchOpen(true); }}
                    >
                        <Search size={22} strokeWidth={1} />
                    </Link>
                    <Link to={isLoggedIn ? "/users/dashboard" : "/users/login"} className="icon-link d-none d-md-block">
                        <User size={22} strokeWidth={1} />
                    </Link>
                    <Link
                        to="#"
                        className="icon-link position-relative"
                        onClick={(e) => { e.preventDefault(); setIsCartOpen(true); }}
                    >
                        <ShoppingBag size={22} strokeWidth={1} />
                        {cartCount > 0 && <span className="cart-icon-badge">{cartCount}</span>}
                    </Link>
                </div>
            </header>

            {/* ── OVERLAYS ── */}

            {/* 1. SEARCH */}
            <div className="manual-overlay" ref={searchOverlayRef}>
                <div className="search-bg" />

                <Link
                    className="close-btn-luxury close-search"
                    style={{ right: "3rem" }}
                    onClick={handleCloseSearch}
                >
                    <X size={35} />
                </Link>

                <div className="search-content container d-flex flex-column align-items-center justify-content-center h-100 position-relative">
                    <h6 style={{ color: "var(--color-accent-main)", letterSpacing: "4px" }}>
                        CURATED SEARCH
                    </h6>

                    {/* Input */}
                    <input
                        type="text"
                        className="luxury-input"
                        placeholder="What are you looking for?"
                        autoFocus
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />

                    {/* ── Product Results Dropdown ── */}
                    {searchText.trim() && (
                        <div className="search-dropdown">

                            {/* Loading */}
                            {searchLoading && (
                                <p className="search-dropdown-status">Searching…</p>
                            )}

                            {/* No results */}
                            {!searchLoading && searchProducts.length === 0 && (
                                <p className="search-dropdown-status">No products found for "{searchText}"</p>
                            )}

                            {/* Product list */}
                            {!searchLoading && searchProducts.map((product) => {
                                const image = product?.thumbnail || product?.images?.[0];
                                const price = product?.variants?.[0]?.price || product?.price;

                                return (
                                    <Link
                                        key={product._id}
                                        to={`/shop/${product.slug}`}
                                        className="search-item text-decoration-none"
                                        onClick={handleProductClick}
                                    >
                                        <img src={image} className="search-img" alt={product.title} />
                                        <div>
                                            <p className="search-title">{product.title}</p>
                                            <p className="search-price">₹{price?.toLocaleString("en-IN")}</p>
                                        </div>
                                    </Link>
                                );
                            })}

                            {/* View all */}
                            {!searchLoading && searchProducts.length > 0 && (
                                <Link
                                    to={`/shop?search=${searchText}`}
                                    className="search-view-all"
                                    onClick={handleProductClick}
                                >
                                    View all results →
                                </Link>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* 2. CART */}
            <CartOffCanvas isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />

            {/* 3. MOBILE MENU */}
            <div className="manual-overlay" ref={menuOverlayRef}>
                <div className="menu-bg" style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.5)" }} />
                <div className="sidebar menu-sidebar d-flex flex-column">
                    <button className="close-btn-luxury" style={{ right: "2rem" }} onClick={() => setIsMenuOpen(false)}>
                        <X size={28} />
                    </button>
                    <span className="brand-logo mb-5" style={{ fontSize: "1.5rem" }}>
                        <img src={config?.logo} alt={config?.title} />
                    </span>
                    <div className="d-flex flex-column">
                        {categories && categories.length > 0 ? (
                            categories.map((cat) => (
                                <Link
                                    key={cat._id}
                                    to={`/categories/${cat.slugPath}`}
                                    className="menu-link nav-link-item ms-0 mb-4 fs-3"
                                    onClick={() => setIsMenuOpen(false)}
                                >
                                    {cat.name}
                                </Link>
                            ))
                        ) : null}
                        {staticNavLinks.map((link, i) => (
                            <Link
                                key={i}
                                to={link.path}
                                className="menu-link nav-link-item ms-0 mb-4 fs-3"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                {link.label}
                            </Link>
                        ))}
                        <Link
                            to={isLoggedIn ? "/users/dashboard" : "/users/login"}
                            className="menu-link nav-link-item ms-0 mb-4 fs-3"
                            onClick={() => setIsMenuOpen(false)}
                        >
                            {isLoggedIn ? "My Account" : "Login"}
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;